import { ApiError } from '@frontend/api-utils';
import { EntityType } from '@frontend/common';
import { ErrorHandler } from '@frontend/error-handler';
import { useAccountRepository } from '@frontend/repository';
import { RoleClient } from '@frontend/role/api';
import { Role } from '@frontend/role/types';
import { useEffect, useState } from 'react';

import { ProfileRolesListProps } from './profile-roles-list.component';

const ID = 'profile-roles-list';

const useProfileRolesList = (props: ProfileRolesListProps) => {
    const { currentAccount } = useAccountRepository();
    const [roles, setRoles] = useState<Role[] | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        if (!currentAccount || !props.userId) return;

        setIsLoading(true);

        RoleClient.fetchEntityRoles(currentAccount, EntityType.USER, props.userId ?? '')
            .then((res) => {
                setRoles(res?.results ?? []);
                setIsLoading(false);
            })
            .catch((err: ApiError) => {
                ErrorHandler.handleError({ error: err });
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [currentAccount, props.userId]);

    return { roles, isLoading };
};

export default useProfileRolesList;
